var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("h2", [_vm._v(_vm._s(_vm.title) + "のスタイルをご選択ください。")]),
      _vm._v(" "),
      _c("div", [
        _vm._v("エンドパネル/カウンターの色柄は、扉と同色になります。")
      ]),
      _vm._v(" "),
      [
        _c("div", { staticClass: "colorPallet" }, [
          _c("div", [
            _c("img", { attrs: { src: _vm.selectColorStyle.colorStyleImage } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "style_list" }, [
            _c(
              "ul",
              _vm._l(_vm.styleList, function(style, index) {
                return _c("li", { key: "style-" + index }, [
                  _c("div", { staticClass: "radio" }, [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        id: "style_" + index,
                        name: "style"
                      },
                      domProps: {
                        checked:
                          style.colorStyleId ===
                          _vm.selectColorStyle.colorStyleId
                      },
                      on: {
                        change: function($event) {
                          _vm.$emit("changeColorStyle", style)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "radio-label",
                        attrs: { for: "style_" + index }
                      },
                      [_vm._v(_vm._s(style.colorStyleName))]
                    )
                  ])
                ])
              })
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0067566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0067566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/input/color/DcColorStyle.vue
// module id = null
// module chunks = 